import React from 'react';
import {AppLayout} from 'sections/services-marketplace/experts/components';
import {SkeletonExpertDetails, SkeletonServiceListings} from '../components';

export function ProfileIndexSkeleton() {
  return (
    <AppLayout>
      <AppLayout.Container slim>
        <AppLayout.Section size="TwoThirds">
          <SkeletonExpertDetails />
        </AppLayout.Section>
      </AppLayout.Container>
      <AppLayout.Container slim>
        <SkeletonServiceListings />
      </AppLayout.Container>
    </AppLayout>
  );
}
